import styled from 'styled-components'
import { Button } from '@mui/material';
import {StyledButton} from "../Buttons/DefaultButton/DefaultButton.styles";

export const Container = styled.form<{isSignUpPage?: boolean}>`
    flex-direction: column;
    height: 100%;
    background-color: white;
    padding: 0 1rem;
    overflow: auto;
    
    .modalBody {
        margin: 2rem 0 0;
    }
    
    .modalFooter {
        text-align: center;
        margin-top: 1rem;
    }
    
    .stickyBottom {
        position: fixed;
        bottom: 0;
        width: 100%;
        display: flex;
        justify-content: ${props => props.isSignUpPage ? 'start' : 'center'};
        margin-left: -1rem;

        .submitButton {
            margin: 0 1rem 2rem !important;
            max-width: 30rem;
        }

        .onCloseBtn {
            max-width: 30rem;
        }
    }
    
    .submitButton {
        margin-bottom: 2rem !important;
    }
    
    .marginBody {
        margin-bottom: 6rem;
    }
    
    @media (max-width: 768px) {
        .modalBody {
            margin: 1rem 0 0;
        }
        .marginBody {
            margin-bottom: 6rem;
        }
    }
`

export const UnderlineTextButton = styled(Button)({
    textTransform: 'none', 
    textDecoration: 'underline',
    fontWeight: '600',
    cursor: 'pointer',  // Ensures cursor is always a pointer
  '&:hover': {
    textDecoration: 'underline',  // Keeps underline on hover
    backgroundColor: 'transparent',  // Prevents background color change on hover
  },
  '&:focus': {
    textDecoration: 'underline',  // Keeps underline on focus
    backgroundColor: 'transparent',  // Prevents background color change on focus
  },
  '&:active': {
    textDecoration: 'underline',  // Keeps underline when active
    backgroundColor: 'transparent',  // Prevents background color change when active
  },
    '&::first-letter': {
      textTransform: 'uppercase'
    },
    '& .MuiButton-label': {
      textTransform: 'lowercase',
      '&::first-letter': {
        textTransform: 'uppercase'
      }
    },
    '& .MuiButton-label::after': {
      content: '" "',  // Add a space after each word
      whiteSpace: 'pre'  // Preserve the space
    }
  });

  export const PrimaryButton = styled(StyledButton)`
    max-width: 30rem !important;
    margin: auto !important;
  `

  export const DeleteButton = styled(StyledButton)`
  max-width: 15rem !important;
  margin: 2rem auto !important;
  border-color: var( --primary-main, #FB7672) !important;
  color: var( --primary-main, #FB7672) !important;
  
`